<div class="container">
    <h1 class="mt120">Христианские инструменты служения на русском языке</h1>
    <hr class="mb-0" />
</div>


<div class="mainContnet">
    <div class="container">
        <p *ngFor="let data of linkarrays"><a [routerLink]="booklink(data.linkName)"><strong>{{data.name}}</strong></a>
            <br>
            {{data.linkDescription}}
        </p>


        <div class="mt-5">
            <p class="note"><strong>заметка: </strong>iTIM курсы требуют личного изучения около часа для каждого урока .
                Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут
                курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя,
                который изучил как урок в течение недели, и материал в руководстве Вождя.</p>
        </div>
    </div>
    <app-static-footer></app-static-footer>
</div>